import { ComponentProps, FC } from 'react';
import { useApiQuery } from '../query/hooks';
import { LoadableSelect } from '../form/LoadableSelect';
import { MenuItem, Select } from '@mui/material';
import { graphql } from '../gql';

const listTouchpointQuery = graphql(`
	query activitySelect_listTouchpoint($phaseId: UUID!) {
		listTouchpoint(filter: { phase: { id: { eq: $phaseId } }, type: { eq: activity } }, orderBy: { order: asc }) {
			id
			activity {
				id
				name
			}
		}
	}
`);

type Props = ComponentProps<typeof Select<string>> &
	Readonly<{
		phaseId?: string;
		loading?: boolean;
	}>;

const isNonNull = <Value,>(value: Value): value is NonNullable<Value> => {
	return value != null;
};

const ActivitySelect: FC<Props> = ({ phaseId, value, loading, disabled, ...props }) => {
	const { isLoading: isQueryLoading, data } = useApiQuery(listTouchpointQuery, {
		enabled: phaseId != null,
		variables: { phaseId: phaseId ?? '' },
	});

	const activities = data?.listTouchpoint.map((touchpoint) => touchpoint.activity).filter(isNonNull) ?? [];

	return (
		<LoadableSelect
			{...props}
			disabled={disabled || phaseId == null}
			loading={loading || (phaseId != null && isQueryLoading)}
			value={value || '' /* value cannot be undefined in order to keep the input controlled */}
		>
			{activities.map((activity) => (
				<MenuItem key={activity.id} value={activity.id}>
					{activity.name}
				</MenuItem>
			))}
		</LoadableSelect>
	);
};

export { ActivitySelect };
